import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import { InputMain } from '@/components/ui/inputs'
// import Select from 'react-select/dist/declarations/src/stateManager'
import SelectRole from '@/components/ui/common-form-signup/components/role'
import PhoneInput from 'react-phone-input-2'

const RegisterWithRole = ({
  control,
  fields,
  errors,
  append,
  remove,
  requestCallback,
}) => {
  const customStyles = {
    avatar: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      marginRight: '10px',
    },
    name: {
      fontWeight: 'bold',
      fontSize: '16px',
      marginBottom: '2px',
    },
    username: {
      fontSize: '14px',
      color: '#666',
    },
  }

  const CustomComponent = (props) => {
    const { innerProps, innerRef, data, isSelected } = props
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px',
          color: '#333',
          background: isSelected ? '#F9FAFB' : '',
        }}
        className="hover:bg-[#F9FAFB] cursor-pointer"
      >
        <img src={data.imageUrl} alt={data.label} style={customStyles.avatar} />
        <div>
          <div style={customStyles.name}>{data.label}</div>
          <div style={customStyles.username}>@{data.value}</div>
        </div>
      </div>
    )
  }
  return (
    <>
      <div className="grid grid-cols-1">
        <InputMain className="sm:gap-2 sm:border-b-0">
          <InputMain.Label
            label="Full name"
            htmlFor="Full name"
            className="text-left"
          />
          <div className="">
            <Controller
              name="name"
              control={control}
              defaultValue=""
              render={({ field }) => {
                return (
                  <InputMain.Input
                    id="name"
                    className="sm:col-span-2"
                    placeholder="Enter username"
                    onChange={() => {}}
                    inputContainer="md:h-11"
                    // error={errors['email']?.message}
                    // disabled={isPending}
                    {...field}
                  />
                )
              }}
            />
            {errors['name']?.message && (
              <div className="mt-2 text-xs text-red-600 text-start">
                <span className="text-xs text-red-600 ">
                  {errors['name']?.message}
                </span>
              </div>
            )}
          </div>
        </InputMain>
        {requestCallback && (
          <InputMain className="sm:gap-2 sm:border-b-0">
            <InputMain.Label
              label="Phone"
              htmlFor="Full name"
              className="text-left"
            />
            <div className="">
              <Controller
                name="phone"
                control={control}
                defaultValue=""
                render={({ field }) => {
                  return (
                    <div className="relative text-left">
                      <PhoneInput
                        country="gb"
                        inputProps={{
                          name: 'phone',
                          id: 'phone',
                          type: 'tel',
                        }}
                        containerClass="w-full rounded-lg relative mt-1 shadow-sm block phone-input"
                        inputClass="h-11  flex-1 block w-full min-w-0 text-v8-ink placeholder:text-v8-mut border-v8-line  focus:ring-v8-blue focus:border-v8-blue rounded-lg sm:text-base"
                        dropdownClass="text-black p-1 rounded-lg"
                        // buttonClass="inline-flex items-center px-3.5 py-3 text-sm md:text-base text-v8-mut border border-r-0 border-v8-line rounded-l-lg bg-cblue-50"
                        buttonClass=" hover:rounded-l-lg rounded-l-lg bg-white  bor"
                        {...field}
                        ref={null}
                      />
                      {errors['phone']?.message && (
                        <div className="mt-2 text-xs text-red-600 text-start">
                          <span className="text-xs text-red-600 ">
                            {errors['phone']?.message}
                          </span>
                        </div>
                      )}
                    </div>
                  )
                }}
              />
              {errors['name']?.message && (
                <div className="mt-2 text-xs text-red-600 text-start">
                  <span className="text-xs text-red-600 ">
                    {errors['name']?.message}
                  </span>
                </div>
              )}
            </div>
          </InputMain>
        )}

        <SelectRole
          control={control}
          fields={fields}
          append={append}
          remove={remove}
          errors={errors}
        />

        <InputMain className="sm:gap-2 sm:border-b-0">
          <InputMain.Label
            label="Email"
            htmlFor="email"
            className="text-left"
          />
          <div className="">
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => {
                return (
                  <InputMain.Input
                    id="email"
                    className="sm:col-span-2"
                    placeholder="Enter email"
                    onChange={() => {}}
                    inputContainer="md:h-11"
                    // error={errors['email']?.message}
                    // disabled={isPending}
                    {...field}
                  />
                )
              }}
            />

            {errors['email']?.message && (
              <div className="mt-2 text-xs text-red-600 text-start">
                <span className="text-xs text-red-600 ">
                  {errors['email']?.message}
                </span>
              </div>
            )}
          </div>
        </InputMain>
        <InputMain className="sm:gap-2 sm:border-b-0">
          <InputMain.Label
            label="Password"
            htmlFor="password"
            className="text-left"
          />
          <div className="">
            <Controller
              name="password"
              control={control}
              defaultValue=""
              render={({ field }) => {
                return (
                  <InputMain.Input
                    id="password"
                    inputType={'password'}
                    className="sm:col-span-2"
                    placeholder="Enter your password"
                    onChange={() => {}}
                    inputContainer="md:h-11"
                    // error={errors['password']?.message}
                    // disabled={isPending}
                    {...field}
                  />
                )
              }}
            />
            {errors['password']?.message && (
              <div className="mt-2 text-xs text-red-600 text-start">
                <span className="text-xs text-red-600 ">
                  {errors['password']?.message}
                </span>
              </div>
            )}
          </div>
        </InputMain>
      </div>
    </>
  )
}

export default RegisterWithRole
